import { ReportColumns, splitNestedColumns } from '@/pages/Reports/DynamicReport/components/ReportTable/utils';

import { ReportInput } from '@/models/gen/graphql';

export const REQUIRED_PARAMS = ['startDatetime', 'endDatetime'] as const;
export const OPTIONAL_PARAMS = ['userSessionTimezone'] as const;
export const LIST_PARAMS = ['airports', 'drivers', 'roleIds'] as const;

export type TrainingReportPdfParams = {
  input: ReportInput;
  missing: string[];
};

export const splitList = (value: string | null): string[] =>
  (value || '')
    .split(',')
    .map((item: string): string => item.trim())
    .filter(Boolean);

export const parseTrainingReportPdfParams = (searchParams: URLSearchParams): TrainingReportPdfParams => {
  const input: Record<string, unknown> = {};
  const missing: string[] = [];
  REQUIRED_PARAMS.forEach((key) => {
    const value = searchParams.get(key);
    if (value) input[key] = value;
    else missing.push(key);
  });
  OPTIONAL_PARAMS.forEach((key) => {
    const value = searchParams.get(key);
    if (value) input[key] = value;
  });
  LIST_PARAMS.forEach((key) => {
    const values = splitList(searchParams.get(key));
    input[key] = values.length ? values : null;
  });
  return { input: input as ReportInput, missing };
};

// The BE sends zero durations as "0.0"; show them as "0"
const ZERO_VALUE = /^-?0+(\.0+)?$/;
export const formatZero = (value: string): string => (ZERO_VALUE.test(value.trim()) ? '0' : value);

export type TrainingReportCity = {
  key: string;
  values: Record<string, string>;
  childColumns: ReportColumns | undefined;
  drivers: Record<string, string>[];
};

// City rows are keyed by their first column value, since report rows carry no backend id.
export const parseTrainingReportCities = (rows: any[] = [], columns: ReportColumns = {}): TrainingReportCity[] => {
  const [cityColumn] = Object.keys(columns);
  return rows.map((row: any): TrainingReportCity => {
    const { childColumns, childRows } = splitNestedColumns(row?.children || []);
    return {
      key: String(row?.values?.[cityColumn] ?? ''),
      values: row?.values || {},
      childColumns,
      drivers: childRows.map((child: any) => child?.values || {}),
    };
  });
};

export type TrainingReportPdfData = {
  params: TrainingReportPdfParams;
  header: Record<string, { name?: string; description?: string; value?: string }>;
  columns: ReportColumns;
  cities: TrainingReportCity[];
};
